export default __webpack_public_path__ + "static/4-3a4eb4302ca4d1a4c94a614bdf64efa2.jpeg";